import React from "react";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import { ButtonContainer, DivContainer } from "./Communication.styled";
import emailIcon from "@icons/ic-email.svg";
import phoneIcon from "@icons/ic-phone.svg";
import mobilePhoneIcon from "@icons/ic-mobile-phone.svg";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../RelatedContactList.styled";
import "../../RelatedContactList.scss";

const Communication = (props) => {
  const { t, data } = props;
  return (
    <>
      {!!data.status && (
        <DivBackgroundFullOpacity>
          <ButtonContainer>
            {data?.email !== null && data?.email !== "" && (
              <>
                <DivContainer>
                  <Image
                    src={emailIcon}
                    alt={t("EMAIL")}
                    title={t("EMAIL")}
                    className="contact-notes-list__image-communication-icon"
                  />
                  {data.email}
                </DivContainer>
                <br></br>
              </>
            )}
            {data?.mobilePhone !== null && data?.mobilePhone !== "" && (
              <DivContainer>
                <Image
                  src={mobilePhoneIcon}
                  alt={t("MOBILE")}
                  title={t("MOBILE")}
                  className="contact-notes-list__image-communication-icon"
                />
                {data.mobilePhone}
              </DivContainer>
            )}
            {data?.phone !== null && data?.phone !== "" && (
              <DivContainer>
                <Image
                  src={phoneIcon}
                  alt={t("PHONE")}
                  title={t("PHONE")}
                  className="contact-notes-list__image-communication-icon"
                />
                {data.phone}
              </DivContainer>
            )}
          </ButtonContainer>
        </DivBackgroundFullOpacity>
      )}
      {!data.status && (
        <DivBackgroundLowOpacity>
          <ButtonContainer>
            {data?.email !== null && data?.email !== "" && (
              <>
                <DivContainer>
                  <Image
                    src={emailIcon}
                    alt={t("EMAIL")}
                    title={t("EMAIL")}
                    className="contact-notes-list__image-communication-icon"
                  />
                  {data.email}
                </DivContainer>
                <br></br>
              </>
            )}
            {data?.mobilePhone !== null && data?.mobilePhone !== "" && (
              <DivContainer>
                <Image
                  src={mobilePhoneIcon}
                  alt={t("MOBILE")}
                  title={t("MOBILE")}
                  className="contact-notes-list__image-communication-icon"
                />
                {data.mobilePhone}
              </DivContainer>
            )}
            {data?.phone !== null && data?.phone !== "" && (
              <DivContainer>
                <Image
                  src={phoneIcon}
                  alt={t("PHONE")}
                  title={t("PHONE")}
                  className="contact-notes-list__image-communication-icon"
                />
                {data.phone}
              </DivContainer>
            )}
          </ButtonContainer>
        </DivBackgroundLowOpacity>
      )}
    </>
  );
};

export default withTranslation()(Communication);
